import PropTypes from "prop-types";
import { forwardRef } from "react";
import classNames from "classnames";

let TripBarItemHeader = forwardRef(
  ({ as = "p", tag: Tag = as, className, children, ...props }, ref) => (
    <Tag
      className={classNames("label", "toolbarItem-header", className)}
      ref={ref}
      {...props}
    >
      {children}
    </Tag>
  )
);

TripBarItemHeader.propTypes = {
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  className: PropTypes.string,
  children: PropTypes.any
};

export { TripBarItemHeader };
